module.exports = __webpack_public_path__ + "static/media/sc.3af06a01.png";